var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "my-bookings-item" }, [
    _c("div", { staticClass: "lg:grid lg:grid-cols-12 lg:gap-2" }, [
      _c("div", { staticClass: "col-span-1 mb-3 md:mb-0 flex items-center" }, [
        _c("img", {
          staticClass: "my-bookings-item__image",
          attrs: { src: _vm.booking.property.listingMainPhoto, alt: "image" }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-span-4 grid grid-cols-4 gap-2 mb-1 md:mb-0" },
        [
          _c("div", { staticClass: "col-span-3 my-auto" }, [
            _c("h4", { staticClass: "font-semibold" }, [
              _vm._v(_vm._s(_vm.booking.property.listingAddressIn))
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.booking.property.postcode) +
                  ", " +
                  _vm._s(_vm.booking.property.location.name)
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-span-1 my-auto text-right lg:text-left" },
            [
              _c(
                "span",
                { staticClass: "my-bookings-item__price whitespace-nowrap" },
                [_vm._v("€ " + _vm._s(_vm.booking.price))]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "block" }, [
                _vm._v(
                  " / " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.common &&
                        _vm.locales.common.mon
                    )
                )
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "my-bookings-item__row col-span-2" }, [
        _c("span", { staticClass: "my-bookings-item__row-definition" }, [
          _vm._v(
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.property_type
            )
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex flex-col items-end lg:items-center" }, [
          _c("span", [_vm._v(_vm._s(_vm.booking.property.type.value))]),
          _vm._v(" "),
          _c("span", { staticClass: "text-[12px]" }, [
            _vm._v(_vm._s(_vm.booking.property.no_bedrooms + " bedrooms"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "my-bookings-item__row col-span-1" }, [
        _c("span", { staticClass: "my-bookings-item__row-definition" }, [
          _vm._v(
            _vm._s(
              _vm.locales && _vm.locales.common && _vm.locales.common.period
            )
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex md:flex-col" }, [
          _c("span", { staticClass: "whitespace-nowrap" }, [
            _vm._v(_vm._s(_vm._f("formatDate2")(_vm.booking.start_date)) + " -")
          ]),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm._f("formatDate2")(_vm.booking.end_date)))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "my-bookings-item__row col-span-2" }, [
        _c("span", { staticClass: "my-bookings-item__row-definition" }, [
          _vm._v(
            _vm._s(
              _vm.locales && _vm.locales.common && _vm.locales.common.status
            )
          )
        ]),
        _vm._v(" "),
        _vm.booking.is_approved === null || _vm.booking.is_approved == 0
          ? _c("span", { staticClass: "status-marker status-marker--orange" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.locales &&
                      _vm.locales.common &&
                      _vm.locales.common.requested
                  ) +
                  "\n      "
              )
            ])
          : _vm.booking.is_approved == 1 &&
            new Date(_vm.booking.start_date) > new Date()
          ? _c("span", { staticClass: "status-marker status-marker--green" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.locales &&
                      _vm.locales.common &&
                      _vm.locales.common.upcoming
                  ) +
                  "\n      "
              )
            ])
          : _vm.booking.is_approved == 1 &&
            new Date(_vm.booking.end_date) < new Date()
          ? _c("span", { staticClass: "status-marker status-marker--gray" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.locales && _vm.locales.common && _vm.locales.common.past
                  ) +
                  "\n      "
              )
            ])
          : _vm.booking.is_approved == -1
          ? _c(
              "span",
              { staticClass: "status-marker status-marker--gray-disabled" },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.common &&
                        _vm.locales.common.rejected
                    ) +
                    "\n      "
                )
              ]
            )
          : _vm.booking.is_approved == -2
          ? _c(
              "span",
              { staticClass: "status-marker status-marker--gray-disabled" },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.common &&
                        _vm.locales.common.cancelled
                    ) +
                    "\n      "
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "my-bookings-item__buttons-block col-span-2" }, [
        _c(
          "a",
          {
            staticClass: "theme-btn theme-btn--small theme-btn--theme",
            attrs: {
              href:
                (_vm.lang != "nl" ? "/" + _vm.lang : "") +
                "/bookings/" +
                _vm.booking.id
            }
          },
          [
            _vm._v("\n        " + _vm._s(_vm.viewDetailsText) + "\n        "),
            _c("span", { staticClass: "icon-thin-right text-[20px]" })
          ]
        ),
        _vm._v(" "),
        _vm.booking.is_paid
          ? _c("div", { staticClass: "my-bookings-item__paid-text" }, [
              _c("span", { staticClass: "icon-check-circle" }),
              _vm._v(" "),
              _c("p", {}, [_vm._v(_vm._s(_vm.bookingPaidText))])
            ])
          : _vm.booking.is_approved == 1 &&
            new Date(_vm.booking.start_date) > new Date()
          ? _c(
              "button",
              {
                staticClass: "theme-btn theme-btn--small theme-btn--info",
                on: {
                  click: function($event) {
                    return _vm.makePayment(_vm.booking.id)
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(_vm.makePaymentText) + "\n      ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.booking.is_approved === null || _vm.booking.is_approved == 0
          ? _c(
              "button",
              {
                staticClass:
                  "theme-btn theme-btn--small theme-btn--destructive",
                on: {
                  click: function($event) {
                    return _vm.deleteBooking(_vm.booking.id)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.rejectBookingText))]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4ac1536", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4ac1536","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/MyBookingItem.vue
// module id = 734
// module chunks = 1